import { useContext } from 'react';
import getBasket from '../../../../services/content-api/endpoints/basket/recent/get';
import { BasketStateContext } from '../basket.provider';
import { ProductLineItemType } from '../../../../models/product-line-item-type';

const useGetRecentBasketItems: () => () => Promise<
  ProductLineItemType[]
> = () => {
  const state = useContext(BasketStateContext);

  return async () => {
    if (!state?.recentId) {
      return [];
    }

    const basket = await getBasket(state.recentId);

    return basket?.products.slice(0, 15) || [];
  };
};

export default useGetRecentBasketItems;
